import React from 'react';

export default function NotFound(props) {
    return (
        <div style={{ paddingTop: '170px', }} className="container">
            <div>
                <p className="h2">404 - Page Not Found</p>
                <p>The page you are looking for does not exist.</p>
                <p>Go back to <a href="/">Home</a></p>
            </div>
        </div>
    )
}